import React, { useState } from "react";
import { BaseButtons } from "../../../../../../../../components/atoms";
import { BlackAndWhite } from "../../../../../../../../themes/Colors";

const CategorySelector = ({
  categoriesArray,
  setSelectedCategory,
  selectedCategory,
}) => {
  const [categoryPopUp, setCategoryPopUp] = useState(false);
  return (
    <div style={{ position: "relative", width: 300, marginTop: 10 }}>
      <BaseButtons
        label={selectedCategory ? selectedCategory : "Click to select Category"}
        mini={true}
        marginTopFalse={true}
        size={300}
        onClick={() => setCategoryPopUp(true)}
      />
      {categoriesArray && categoryPopUp ? (
        <div
          style={{
            position: "absolute",
            top: 0,
            width: "100%",
            // borderStyle: "solid",
            backgroundColor: BlackAndWhite.secondary,
            zIndex: 200,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxHeight: 300,
            overflowY: "scroll",
            overflowX: "hidden",
            // borderWidth: 1,
            WebkitBoxShadow: "0px 0px 7px 2px #00000020",
          }}
        >
          {categoriesArray
            ? categoriesArray.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      color: BlackAndWhite.primary,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <BaseButtons
                      mini={true}
                      marginTop={5}
                      size={"95%"}
                      label={item.categoryName}
                      onClick={() => {
                        setSelectedCategory(item.categoryName);
                        setCategoryPopUp(false);
                      }}
                    />
                  </div>
                );
              })
            : "loading"}
        </div>
      ) : null}
    </div>
  );
};

export default CategorySelector;
